var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"modal-nav-item",class:{ active: _vm.step === _vm.currentStep, activeBar: _vm.step <= _vm.currentStep }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }